import React, { useState } from 'react';
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Switch,
  TextField,
  Typography,
  Tooltip,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import * as Yup from 'yup';
import MuiPhoneNumber from 'material-ui-phone-number';
import { stringConstants } from '../../constants/stringConstants';
import { Formik } from 'formik';
import moment from 'moment';
import {
  DatepickerStartDate,
  globalDateEntity,
  globalPageTypeEntity,
} from '../../constants/applicationConstants';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { TagChips } from '../../submodule';
import { useStoreActions } from 'easy-peasy';
import { useHistory } from 'react-router-dom';
import { capitalize } from '../../utils/common';
const url_placeholder = 'https://www.abc.com';
const defaultValue = {
  title: '',
  shortname: '',
  current_status: 'DRAFT',
  debugging_mode: 'off',
  address: '',
  state: '',
  zipcode: '',
  city: '',
  fax: '',
  email: '',
  phone: '',
  weburl: '',
  inactivedate: null,
  effectivedate: new Date(),
  allowed_domains: [],
  pa_preference: '',
};
export const OrganizationForm = ({ onClose , type, formDate=defaultValue}) => {
  const [fieldData,] = useState(formDate);
  const history = useHistory();
  const [hiddenItems, setHiddenItems] = useState([]);
  const [orgAction, commonAction] = useStoreActions((actions) => [
    actions.organization,
    actions.common,
  ]);
  const schema = Yup.object().shape({
    shortname: Yup.string()
      .required(stringConstants.requiredValidationMsg)
      .matches(/^\S*$/, "Short Name should not have any spaces")
      .max(
        50,
        `Organization Short Name ${stringConstants.fiftyCharLimitValidMsg}`,
      ),
    title: Yup.string()
      .max(100, `Organization Name ${stringConstants.hundredCharLimitValidMsg}`)
      .required(stringConstants.requiredValidationMsg),
    address: Yup.string()
      .max(200, `Address ${stringConstants.twoHundredCharLimitValidMsg}`)
      .required(stringConstants.requiredValidationMsg),
    city: Yup.string()
      // .required(stringConstants.requiredValidationMsg)
      .max(
        70,
        `City ${stringConstants.seventyCharLimitValidMsg}`,
      ),
    state: Yup.string()
      .max(10, `State Code ${stringConstants.tenthCharLimitValidMsg}`)
      .required(stringConstants.requiredValidationMsg),
    zipcode: Yup.string()
      .max(15, `Zip Code ${stringConstants.fifteenCharLimitValidMsg}`)
      .required(stringConstants.requiredValidationMsg),
    phone: Yup.string()
      .optional()
      .nullable()
      .matches(
        /^\+[1]((\s)[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4})?$/g, //NOSONAR
        stringConstants.phoneValidationMsg,
      ),
    fax: Yup.string()
      .optional()
      .nullable()
      .matches(
        /^[(]?\d{3}[)]?[(\s)?.-]\d{3}[\s.-]\d{4}$/g, //NOSONAR
        stringConstants.faxNumberValidMsg,
      )
      .max(15, `Fax ${stringConstants.fifteenCharLimitValidMsg}`),
    email: Yup.string()
      .nullable()
      .email(stringConstants.validEmailMsg)
      .max(100, `Email ${stringConstants.hundredCharLimitValidMsg}`),
    weburl: Yup.string()
      .matches(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&=]*)/g, //NOSONAR
        stringConstants.urlValidMsg,
      )
      .max(200, `URL ${stringConstants.twoHundredCharLimitValidMsg}`),
    current_status: Yup.string().required(stringConstants.requiredValidationMsg),
    effectivedate: Yup.date()
      .required(stringConstants.requiredValidationMsg)
      .nullable()
      .typeError(stringConstants.invalidDate)
      .min(new Date(DatepickerStartDate), stringConstants.minDate),
    inactivedate: Yup.date()
      .nullable()
      .typeError(stringConstants.invalidDate)
      .min(new Date(DatepickerStartDate), stringConstants.minDate),
    allowed_domains: Yup.array()
      .of(
        Yup.string().matches(
          /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i,
          'A valid domain name required e.g. example.com',
        ),
      )
      .required(stringConstants.requiredValidationMsg)
      .typeError('A valid domain name required e.g. example.com'),
    pa_preference: Yup.string().nullable().when('debugging_mode', {
      is: (val) => val == 'on',
      then: Yup.string().required(stringConstants.requiredValidationMsg),
      otherwise: Yup.string().notRequired(),
    }),
  });
  const [isLoading, setIsLoading] = useState(false);
  const submitHandler = (values, { setErrors }) => {
    setIsLoading(true);
    const newValue = { ...values };
    newValue.allowed_domains = newValue.allowed_domains.map((domain) => ({
      domain,
      isDefault: true,
      active: true,
    }));
    if(type === globalPageTypeEntity.edit){
      orgAction
      .updateOrgs(newValue)
      .then((res) => {
        onClose(type);
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.error
          .map((error) => Object.values(error))
          .join(', ');
        commonAction.setSubmitSnackbar({
          status: true,
          error: true,
          messages: errorMessage,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
    }else{
      orgAction
      .addOrgs(newValue)
      .then((res) => {
        onClose();
        history.push(`/organization/${encodeURIComponent(res.data?.data?.PK)}`);
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.error
          .map((error) => Object.values(error))
          .join(', ');
        commonAction.setSubmitSnackbar({
          status: true,
          error: true,
          messages: errorMessage,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
    }
    
  };
  return (
    <Formik
      initialValues={fieldData}
      validationSchema={schema}
      onSubmit={submitHandler}
    >
      {(formikProps) => {
        const {
          values,
          touched,
          errors,
          setFieldValue,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldTouched,
          isValid,
          // dirty,
        } = formikProps;
        return (
          <form noValidate onSubmit={handleSubmit}>
            <Grid
              container
              style={{ padding: 50, margin: '0 -16px' }}
              spacing={2}
            >
              <Grid item sm={6}>
                <Typography variant="h4">{type == globalPageTypeEntity.edit? "Edit": "Add"} Tenant</Typography>
              </Grid>
              <Grid item sm={6} style={{textAlign: 'right'}}>
                {(process.env.REACT_APP_SENTRY_ENVIRONMENT != 'pacheck' && process.env.REACT_APP_SENTRY_ENVIRONMENT != 'pacheck-us') && (
                  <FormControl component="fieldset" style={{marginRight: '40px'}}>
                    <FormGroup>
                      <FormControlLabel style={{marginRight: '0px'}}
                        data-testid="debugging_mode_lable"
                        control={
                          <Switch
                            color="primary"
                            name="debugging_mode"
                            data-testid="debugging_mode"
                            checked={values.debugging_mode === "on" ? true : false}
                            onChange={(event, flag) => {
                              setFieldValue('debugging_mode', flag ? 'on' : 'off', true);
                            }}
                          />
                        }
                        label={'Enable Debugging Mode'}
                      />
                    </FormGroup>
                  </FormControl>
                )}
                <FormControl component="fieldset">
                  <FormGroup>
                    <FormControlLabel style={{marginRight: '0px'}}
                      data-testid="current_status_lable"
                      control={
                        <Switch
                          color="primary"
                          name="current_status"
                          data-testid="current_status"
                          checked={
                            values.current_status == 'APPROVED' ? true : false
                          }
                          onChange={(event) => {
                            const current_status =
                              values.current_status == 'APPROVED'
                                ? 'DRAFT'
                                : 'APPROVED';
                            setFieldValue(
                              'current_status',
                              current_status,
                              true,
                            );
                          }}
                        />
                      }
                      label={capitalize(values.current_status)}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item sm={4}>
                <TextField
                  required
                  fullWidth
                  id="short_name"
                  name="shortname"
                  label="Short Name"
                  data-testid="shortname"
                  variant="outlined"
                  value={values.shortname}
                  onChange={(e, v) => {
                    setFieldValue('shortname', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.shortname && touched.shortname}
                  helperText={
                    errors.shortname && touched.shortname && errors.shortname
                  }
                ></TextField>
              </Grid>
              <Grid item sm={8}>
                <TextField
                  required
                  fullWidth
                  id="title"
                  name="title"
                  label="Title"
                  data-testid="title"
                  variant="outlined"
                  value={values.title}
                  onChange={(e, v) => {
                    setFieldValue('title', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.title && touched.title}
                  helperText={errors.title && touched.title && errors.title}
                ></TextField>
              </Grid>
              <Grid item sm={6}>
                <KeyboardDatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="Effective Date"
                  format={globalDateEntity.datePickerFormat}
                  autoOk
                  fullWidth
                  placeholder={globalDateEntity.datePickerFormat}
                  required
                  id="effectivedate"
                  name="effectivedate"
                  value={values.effectivedate}
                  onChange={(v) => {
                    setFieldValue('effectivedate', v ? moment(v).format(globalDateEntity.datePickerFormat) : '', true);
                  }}
                  onBlur={handleBlur}
                  minDate={new Date(DatepickerStartDate)}
                  minDateMessage={stringConstants.minDate}
                  error={errors.effectivedate && touched.effectivedate}
                  helperText={
                    errors.effectivedate &&
                    touched.effectivedate &&
                    errors.effectivedate
                  }
                />
              </Grid>
              <Grid item sm={6} className={`positionRelative`}>
                <KeyboardDatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="End Date"
                  format={globalDateEntity.datePickerFormat}
                  autoOk
                  fullWidth
                  placeholder={globalDateEntity.datePickerFormat}
                  id="inactivedate"
                  name="inactivedate"
                  value={values.inactivedate}
                  onChange={(v) => {
                    setFieldValue('inactivedate', v ? moment(v).format(globalDateEntity.datePickerFormat) : '', true);
                  }}
                  onBlur={handleBlur}
                  minDate={new Date(DatepickerStartDate)}
                  minDateMessage={stringConstants.minDate}
                  error={errors.inactivedate && touched.inactivedate}
                  helperText={
                    errors.inactivedate &&
                    touched.inactivedate &&
                    errors.inactivedate
                  }
                />
                <Tooltip title="Remove Date">
                  <IconButton
                    className={`closeEndDatePosition`}
                    color="primary"
                    aria-label="Remove Date"
                    onClick={() => { setFieldValue('inactivedate', null); }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item sm={12}>
                <TagChips
                  initData={values.allowed_domains}
                  labelId="allowed-domains-label"
                  id="allowed-domains"
                  placeholder="Allowed domain *"
                  name="allowed_domains"
                  errors={errors}
                  touched={touched}
                  setTouched={setFieldTouched}
                  setFieldValue={setFieldValue}
                  maxTags={1}
                  textCase="lowercase"
                  firstReadOnly={true}
                  hiddenItems={hiddenItems}
                  setHiddenItems={setHiddenItems}
                />

                <FormHelperText
                  className={
                    errors.allowed_domains &&
                    touched.allowed_domains &&
                    errors.allowed_domains
                      ? 'Mui-error'
                      : ''
                  }
                >
                  {errors.allowed_domains &&
                    touched.allowed_domains &&
                    errors.allowed_domains}

                  <p>
                    Input domain name (example.com) and hit enter. (Max 1 domain
                    can be added)
                  </p>
                </FormHelperText>
              </Grid>
              <Grid item sm={12}>
                <TextField
                  required
                  fullWidth
                  id="address"
                  name="address"
                  label="Address"
                  data-testid="address"
                  variant="outlined"
                  value={values.address}
                  onChange={(e, v) => {
                    setFieldValue('address', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.address && touched.address}
                  helperText={
                    errors.address && touched.address && errors.address
                  }
                ></TextField>
              </Grid>
              <Grid item sm={6}>
                <TextField
                  required
                  fullWidth
                  id="state"
                  name="state"
                  label="State"
                  data-testid="state"
                  variant="outlined"
                  value={values.state}
                  onChange={(e, v) => {
                    setFieldValue('state', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.state && touched.state}
                  helperText={errors.state && touched.state && errors.state}
                ></TextField>
              </Grid>
              <Grid item sm={3}>
                <TextField
                  // required
                  fullWidth
                  id="city"
                  name="city"
                  label="City"
                  data-testid="city"
                  variant="outlined"
                  value={values.city}
                  onChange={(e, v) => {
                    setFieldValue('city', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.city && touched.city}
                  helperText={errors.city && touched.city && errors.city}
                ></TextField>
              </Grid>
              <Grid item sm={3}>
                <TextField
                  required
                  fullWidth
                  id="zipcode"
                  name="zipcode"
                  label="Zipcode"
                  data-testid="zipcode"
                  variant="outlined"
                  value={values.zipcode}
                  onChange={(e, v) => {
                    setFieldValue('zipcode', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.zipcode && touched.zipcode}
                  helperText={
                    errors.zipcode && touched.zipcode && errors.zipcode
                  }
                ></TextField>
              </Grid>
              <Grid item sm={6}>
                <MuiPhoneNumber
                  countryCodeEditable={false}
                  id="phone"
                  name="phone"
                  label="Phone"
                  variant="outlined"
                  value={values.phone}
                  fullWidth
                  defaultCountry={'us'}
                  onlyCountries={['us']}
                  onChange={handleChange('phone')}
                  error={errors.phone && touched.phone}
                  helperText={errors.phone && touched.phone && errors.phone}
                  onBlur={handleBlur}
                  className={touched.phone && errors.phone ? 'has-error' : null}
                />
              </Grid>
              <Grid item sm={6}>
                <TextField
                  fullWidth
                  placeholder="(123)-456-7890"
                  id="fax"
                  name="fax"
                  value={values.fax}
                  //onChange={handleChange}
                  onChange={(e, v) => {
                    setFieldValue('fax', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.fax && touched.fax}
                  helperText={errors.fax && touched.fax && errors.fax}
                  label="Fax"
                  variant="outlined"
                />
              </Grid>
              <Grid item sm={values.debugging_mode == 'on' ? 6 : 12}>
                <TextField
                  fullWidth
                  placeholder="example@example.com"
                  id="email"
                  name="email"
                  value={values.email}
                  //onChange={handleChange}
                  onChange={(e, v) => {
                    setFieldValue('email', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.email && touched.email}
                  helperText={errors.email && touched.email && errors.email}
                  label="Email"
                  variant="outlined"
                />
              </Grid>
              {values.debugging_mode == 'on' && (
                <Grid item sm={6}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    required
                    error={errors.pa_preference && touched.pa_preference}
                  >
                    <InputLabel id="demo-simple-select-pa-preference">
                      Checkpoint Logic
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-pa-preference"
                      id="demo-simple-select-pa-handling"
                      placeholder="Checkpoint Logic"
                      name="pa_preference"
                      value={values.pa_preference}
                      onChange={(e) => {
                        setFieldValue('pa_preference', e.target.value);
                      }}
                      label="Checkpoint Logic"
                    >
                      <MenuItem value="bcbsmn">BCBS MN</MenuItem>
                      <MenuItem value="bcbswy">BCBS WY</MenuItem>
                      <MenuItem value="bcbsnd">BCBS ND</MenuItem>
                    </Select>
                    <FormHelperText
                      className={
                        errors.pa_preference &&
                          touched.pa_preference &&
                          errors.pa_preference
                          ? 'Mui-error'
                          : ''
                      }
                    >
                      {errors.pa_preference &&
                        touched.pa_preference &&
                        errors.pa_preference}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              )}
              <Grid item sm={12}>
                <TextField
                  fullWidth
                  placeholder={url_placeholder}
                  id="weburl"
                  name="weburl"
                  value={values.weburl}
                  //onChange={handleChange}
                  onChange={(e, v) => {
                    setFieldValue('weburl', e.target.value, true);
                  }}
                  onBlur={handleBlur}
                  error={errors.weburl && touched.weburl}
                  helperText={errors.weburl && touched.weburl && errors.weburl}
                  label="URL"
                  variant="outlined"
                />
              </Grid>
              <Grid item sm={12}>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                  style={{ marginTop: '10px' }}
                >
                  <Grid item>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={onClose}
                      data-testid="cancel-button"
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      data-testid="submit-button"
                      disabled={!isValid}
                    >
                      {isLoading && (
                        <CircularProgress
                          size={20}
                          color="white"
                          style={{ marginRight: '5px' }}
                        />
                      )}
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        );
      }}
    </Formik>
  );
};
